import * as React from 'react';

import type { SignupApi } from './api';
import type { FlowAction, FlowState } from './flow';

export interface SignupContextValue {
    api: SignupApi;
    flow: FlowState;
    dispatch: React.Dispatch<FlowAction>;
    /** For a lost session (401 `session_*` that a re-claim could not fix): forgets the session, goes
     *  back to the landing and answers true. Any other error answers false: the screen shows it. */
    sessionLost: (error: unknown) => boolean;
}

export const SignupContext = React.createContext<SignupContextValue | null>(null);

export function useSignup(): SignupContextValue {
    const value = React.useContext(SignupContext);
    if (!value) {
        throw new Error('useSignup outside <SignupApp>');
    }
    return value;
}
